module.exports = __webpack_public_path__ + "static/Download_on_the_App_Store_Badge-c9c88c3f22573aad918fac015f8fe848.png";